import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useStyles } from './QAndASidePannel.styles'
import { Typography } from '@mui/material'
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core'
import { faUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'

export interface QAndAContentData {
  icon?: IconDefinition | JSX.Element
  link?: string
  linkedText?: string
  question?: string | JSX.Element
  answer?: string | JSX.Element
}

export interface QAndASidePannelProps {
  content: QAndAContentData[]
}

export const QAndASidePannel = React.memo(
  ({ content }: QAndASidePannelProps) => {
    const { classes: styles } = useStyles()
    return (
      <div className={styles.question} data-testid="q-and-a-side-panel">
        {content.map((item, index) => (
          <div key={index} className={styles.contentWraper}>
            {typeof item.icon === 'object' && 'type' in item.icon ? (
              item.icon
            ) : (
              <FontAwesomeIcon
                icon={item.icon as IconProp}
                className={styles.indexIcon}
              />
            )}
            <div className={styles.qAndAWrapper}>
              <div className={styles.qAndAContainer}>
                <Typography className={styles.questionText}>
                  {item.question}
                </Typography>
                <Typography className={styles.answerText} component="div">
                  {item.answer}{' '}
                  {item.link && (
                    <a
                      className={styles.externalLinkContainer}
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.linkedText && (
                        <Typography
                          variant="body2"
                          className={styles.externalLinkText}
                        >
                          {item.linkedText}
                        </Typography>
                      )}
                      <span
                        style={{ marginLeft: item.linkedText ? '4px' : '0' }}
                      >
                        <FontAwesomeIcon
                          icon={faUpRightFromSquare}
                          className={styles.externalLinkText}
                        />
                      </span>
                    </a>
                  )}
                </Typography>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }
)
